import React from 'react'
import { RouteComponentProps, withRouter } from 'react-router'
import { usePlaceByName } from 'hooks/usePlace'
import { SupportedDestinations } from 'home/constants'
import Heading from 'components/Luxkit/Typography/Heading'
import ExperienceOfferCarousel from 'home/components/OfferCarousels/ExperienceOfferCarousel/ExperienceOfferCarousel'

interface Props extends RouteComponentProps<{ destination: SupportedDestinations}> {
  title: string;
}

function ContentfulExperienceOfferCarousel(props: Props) {
  const { destination } = props.match.params
  const place = usePlaceByName(destination)

  return <ExperienceOfferCarousel place={place} experienceHeading={<Heading variant="heading2" dangerouslySetInnerHTML={{ __html: props.title }}/>}/>
}

export default withRouter(ContentfulExperienceOfferCarousel)
